import { assertNever } from '@kofno/piper';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../EmptyFragment';
import CountStore from '../../CountStore';

interface Props {
  store: CountStore;
}

function SegmentCount({ store }: Props) {
  switch (store.state.kind) {
    case 'loading':
    case 'unavailable':
      return emptyFragment();
    case 'ready':
      return (
        <span className="ml-1.5 tabular-nums text-muted-foreground">
          {store.state.total.toLocaleString()}
        </span>
      );
    default:
      return assertNever(store.state);
  }
}

export default observer(SegmentCount);
